import { deleteSolidDataset, getPodUrlAll } from "@inrupt/solid-client";
// ... import statement for authentication, which includes the fetch function, is omitted for brevity.

import {
  getFile,
  isRawData,
  getContentType,
  getSourceUrl,
  getSolidDataset,
  getThing,
  getStringNoLocale,
  getUrlAll,
  saveFileInContainer,
  getContainedResourceUrlAll,
  createSolidDataset,
  saveSolidDatasetAt,
} from "@inrupt/solid-client";

// import { writeFile } from "fs/promises";
// import * as fs from "fs";

/**
 * If a commonplace book dataset exists in index.ttl at directory uri provided > return, otherwise create one.
 *
 * @param {String} containerUri pod uri with specific folder and / appended at end
 * @param {*} fetch session.fetch
 * @returns returns commonplace book dataset
 */
export async function getOrCreateCommonplaceBook(containerUri, fetch) {
  const indexUrl = `${containerUri}index.ttl`;
  // const fetch = f || window.fetch;
  try {
    // await deleteSolidDataset(indexUrl, { fetch });
    // return;
    const quoteList = await getSolidDataset(indexUrl, { fetch });
    return quoteList;
  } catch (error) {
    if (error.statusCode === 404) {
      const quoteList = await saveSolidDatasetAt(
        indexUrl,
        createSolidDataset(),
        {
          fetch,
        }
      );
      console.log("Qs: ", quoteList);
      return quoteList;
    }
  }
}

/**
 * READ PODS from WebID
 * Returns a list of Pod URLS
 * @param {webID} webID
 * @returns String["URL", "URL1", "URLn"...]
 */
export async function getMyPods(webID) {
  return await getPodUrlAll(webID, { fetch: fetch });
}

/**
 * READ FILE contents from storage fileURL
 * Return file from Pod
 * @param {String} fileURL ie) https://storage.inrupt.com/{uuid}/app-tests/sample.txt
 * @param {session.fetch} fetch ALWAYS use: { session.fetch }
 * @returns {Blob}
 */
export async function readTextFromPodFile(fileURL, fetch) {
  try {
    const file = await getFile(
      fileURL, // File in Pod to Read
      { fetch: fetch } // fetch from authenticated session
    );

    // console.log(`The file is ${isRawData(file) ? "not " : ""}a dataset.`);

    // const fileContent = await file.text();
    // console.log("file text: ", fileContent);

    // const arrayBuffer = await file.arrayBuffer();
    // fs.writeFile(saveAsFilename, new Uint8Array(arrayBuffer));

    return file;
  } catch (err) {
    console.log("ReadTextFromPodFile() error: ", err);
  }
}

/**
 * READ ALL FILES in POD
 * Returns Array of Files in Pod Location
 * @param {String} SolidDatasetUrl
 */

export async function getDatasetsInPod(URL) {
  const podURL =
    // URL ||
    "https://storage.inrupt.com/0a5ee03b-6b80-4473-a777-8606b9804617/app-tests/";

  try {
    const solidDataset = await getSolidDataset(podURL);
    // console.log("Dataset: ", solidDataset);

    return solidDataset;
    // getContainedResourceUrlAll(solidDataset);
  } catch (err) {
    console.error("getDatasetsInPod() error: ", err);
  }
}

/**
 * Get Resource URLS from storage URL
 * @param {object} dataset Solid Dataset object
 */
export async function getContainedResourceURLsInPod(dataset) {
  const ds = dataset;

  try {
    const list = getContainedResourceUrlAll(ds);
    return list;
  } catch (err) {
    console.error("getContainedResourceURLsInPod() error: ", err);
  }
}

/**
 * WRITE FILE to POD
 * Upload data as a file into the targetContainer.
 * Returns message if successful
 *
 * https://docs.inrupt.com/developer-tools/javascript/client-libraries/tutorial/read-write-files/#save-a-file-into-an-existing-container
 */

export async function placeFileInContainer(
  filedata,
  mimetype,
  targetContainerURL,
  slug,
  fetch
) {
  // Check if file already exists first?
  try {
    const savedFile = await saveFileInContainer(
      targetContainerURL, // Container URL
      filedata, // Buffer containing file data
      { slug: slug, contentType: mimetype, fetch: fetch }
    );
    const message = `File saved at ${getSourceUrl(savedFile)}`;
    console.log("saveFileInContainer(): ", message);
    return message;
  } catch (error) {
    console.error("placeFileInContainer() error: ", error);
    return error;
  }
}

/**
 * addNewLineAtWordEnd()
 * @param {String} str
 * @returns String with newline characters every 50 chars
 */
export function addNewLineAtWordEnd(str) {
  let result = "";
  let count = 0;
  for (let i = 0; i < str.length; i++) {
    count++;
    if (count >= 30 && str[i - 1] === " ") {
      result += "\n";
      count = 0;
    }

    result += str[i];
  }
  return result;
}
